var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoBoundary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.143h-7m0 11h7",
    stroke: "#131A4F",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 1.143h-11m0 11h11",
    stroke: "#131A4F",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeDasharray: "1 1"
  })));
}
export default __webpack_public_path__ + "b8de5b474c07e3635a45c8e83127aa73.svg";
export { SvgNoBoundary as ReactComponent };